import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import BreadcrumbsPanelDashboard from '../../components/breadcrumbs-panel-dashboard';
import Overlay from '../../components/overlay';
import BreadcrumbsPanelLinks from '../../components/breadcrumbs-panel-links';
import LoadingComponent from '../../components/loading-component/loading-component-view';
import { useSelector } from 'react-redux';
import ChatBot from '../../components/chatbot/chatbot';
import { VideoTutorials } from 'components/hilfecenter/hilfecenter';
import HelpSection from 'components/greeting-sidebar/greeting-sidebar';
import classes from './dashboard.module.scss';
import classNames from 'classnames';
import SideMenu from '../../components/side-menu';
import { ErrorBoundary } from 'components/error-boundary/error-boundary.redux';
import useCloseSidebarOnChangeLocation from '../../hooks/use-close-sidebar-on-change-location';
import { useLocation } from 'react-router-dom';
import ErrorScreen from '../../components/error-screen';
import useWindowSize from '../../hooks/use-window-size';
import LoadCookieyesScript from 'components/load-cookieyes-script/index';

export const PageContainer = ({ children }) => {
  const location = useLocation();
  const user = useSelector(state => state['app'].user);
  const { windowHeight } = useWindowSize();

  const isCarConfiguratorPage = location.pathname.includes('/konfigurator/');

  useCloseSidebarOnChangeLocation();

  return (
    <>
      {user.companyId ? (
        <div style={{ height: windowHeight }} className='d-flex'>
          {user.roles.length > 0 && <SideMenu key={user.mainRole.id} />}
          <div className='w-100 d-flex f-d-column' style={{ overflow: 'auto' }}>
            <LoadCookieyesScript />
            <BreadcrumbsPanelDashboard />
            <div className={classes.overlay_wrapper}>
              <Overlay noScrollToTop={true} />
              <div className={classNames('scroll-container', classes.breadscrums_wrapper)} style={{ overflow: 'auto' }}>
                <BreadcrumbsPanelLinks />
                <ErrorBoundary errorComponent={<ErrorScreen />}>
                  <Suspense fallback={<Overlay show />}>{children}</Suspense>
                </ErrorBoundary>
              </div>
            </div>
          </div>
          {!isCarConfiguratorPage && (
            <>
              <VideoTutorials />
              <ChatBot key={user.avatar ? '0' : '1'} />
            </>
          )}
          <HelpSection />
          <div id={'meeting_booking'} style={{ height: '99%' }} />
        </div>
      ) : (
        <LoadingComponent />
      )}
    </>
  );
};

PageContainer.propTypes = {
  children: PropTypes.any
};
